export const API_ROOT = "https://aaptaserver.apxor.com"
// export const API_ROOT = "http://34.67.43.188"
// export const API_ROOT = "http://localhost:3000"
